/**
 * The last-known reps, shows and signed in user, mirrored to localStorage.
 *
 * The capture form's rep and show dropdowns come from live queries with no
 * persistence of their own, and AuthContext.jsx's own session check
 * (GET /api/auth/me) has to reach the server before it will treat a stored
 * token as good. A rep opening the app with no signal at all, from a fresh
 * launch, would otherwise be bounced to the login screen (a real network
 * failure there reads the same as a bad token, with nothing to fall back on)
 * and see empty dropdowns even if they did get past it. This is the fallback
 * each of those three reaches for only when the network call itself is
 * unreachable (ApiError status 0), never on a real error like a 403 or an
 * actually revoked token.
 */

const PREFIX = 'tradesync_cache_'

export function cacheValue(key, data) {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(data))
  } catch {
    // Safari private mode, or a full quota. Nothing to do; the next online
    // fetch tries again.
  }
}

export function readCachedValue(key, fallback = null) {
  try {
    const raw = localStorage.getItem(PREFIX + key)
    return raw ? JSON.parse(raw) : fallback
  } catch {
    return fallback
  }
}
